// This file is normally used for setting up analytics and other
// services that require one-time initialization on the client.

import { retrieveLaunchParams } from '@tma.js/sdk-react';
import { init } from './utils/init';
import { mockData } from './utils/mockEnv';

mockData().then(() => {
  try {
    const launchParams = retrieveLaunchParams();

    const debug =
      (launchParams.tgWebAppStartParam || '').includes('debug') ||
      process.env.NODE_ENV === 'development';

    // Configure all application dependencies.
    init({
      debug,
    });
  } catch (e) {
    console.log('Error during initialization:', e);
  }
});
